import axios from "axios";
import { refreshSession } from "./authClient";

const API_BASE = process.env.REACT_APP_API_URL || "";

const apiClient = axios.create({
    baseURL: API_BASE,
    withCredentials: true
});

// Add response interceptor for 401 handling
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                await refreshSession();
                return apiClient(originalRequest);
            } catch (refreshError) {
                window.location.href = "/login";
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export async function getSavingsRate(months = 6, signal) {
    const resp = await apiClient.get("/api/savings", {
        params: { months },
        signal
    });
    return resp.data;
}

export async function getSpendingBreakdown(months = 3, signal) {
    const resp = await apiClient.get("/api/savings/spending", {
        params: { months },
        signal
    });
    return resp.data;
}

export async function getFiNumber(withdrawalRate, months = 6, signal) {
    const params = { months };
    if (withdrawalRate != null) {
        params.withdrawalRate = withdrawalRate;
    }
    const resp = await apiClient.get("/api/savings/fi-number", {
        params,
        signal
    });
    return resp.data;
}

export async function detectTransfers() {
    const resp = await apiClient.post("/api/savings/detect-transfers");
    return resp.data;
}

export async function getClassifiedTransactions(months = 6, signal) {
    const resp = await apiClient.get("/api/savings/transactions", {
        params: { months },
        signal
    });
    return resp.data;
}

export async function createTransactionOverride(transactionId, overrideType, newCategory = null) {
    const resp = await apiClient.post("/api/savings/overrides", {
        transactionId,
        overrideType,
        newCategory,
    });
    return resp.data;
}

export async function deleteTransactionOverride(transactionId) {
    const resp = await apiClient.delete(`/api/savings/overrides/${transactionId}`);
    return resp.data;
}

export async function setFiExpensesOverride(annualExpenses) {
    const resp = await apiClient.post("/api/savings/fi-number/expenses-override", {
        annualExpenses,
    });
    return resp.data;
}

export async function clearFiExpensesOverride() {
    const resp = await apiClient.delete("/api/savings/fi-number/expenses-override");
    return resp.data;
}

export async function setWithdrawalRate(withdrawalRate) {
    const resp = await apiClient.post("/api/savings/fi-number/withdrawal-rate", {
        withdrawalRate,
    });
    return resp.data;
}
